import { render, staticRenderFns } from "./RunningExecutionFooter.vue?vue&type=template&id=12bc580a&"
import script from "./RunningExecutionFooter.vue?vue&type=script&lang=ts&"
export * from "./RunningExecutionFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports